import { Article } from "@/lib/types";
import { COIN_META } from "@/components/layernav/navConfig";
import { MarketContext } from "./MarketContext";
import { GlobalMarketContext, RegulationContext, SecurityContext, LayerIndexModule } from "./RailModules";

export type RegulationRef = {
  slug: string; title: string; countries: string[]; agencies: string[];
  status?: string; impact_level?: string; updated_at?: string;
} | null;

export const CONTEXT_LABELS: Record<string, string> = {
  ASSET_MARKET: "Market Story",
  GLOBAL_MARKET: "Market-Wide",
  REGULATION: "Policy & Regulation",
  SECURITY: "Security Story",
  INSTITUTIONAL: "Institutional",
  RWA: "Tokenization",
  PROTOCOL: "Protocol",
  SECTOR: "Sector Story",
  GENERAL: "Story Context",
};

export const contextLabel = (ctx?: { family: string; subtype?: string | null }): string =>
  ctx?.subtype === "AI_SECURITY" ? "AI Security" : CONTEXT_LABELS[ctx?.family || ""] || "Story Context";

export const relatedHeading = (ctx?: { family: string; asset?: string | null; subtype?: string | null }): string | null => {
  if (!ctx) return null;
  const asset = ctx.asset ? COIN_META[ctx.asset]?.name : null;
  switch (ctx.family) {
    case "ASSET_MARKET": return asset ? `More ${asset} Coverage` : "More Market Coverage";
    case "GLOBAL_MARKET": return "More Market Coverage";
    case "REGULATION": return "More Policy & Regulation";
    case "SECURITY": return ctx.subtype === "AI_SECURITY" ? "More on AI & Security" : "More from Security";
    case "INSTITUTIONAL": return "More Institutional Coverage";
    case "RWA": return "More Tokenization Coverage";
    default: return null;
  }
};

export const ContextModules = ({ article, regulationRef }: {
  article: Article; regulationRef?: RegulationRef;
}) => {
  const ctx = article.context;
  const family = ctx?.family || "GENERAL";
  const hasAsset = (ctx?.assets_detected || []).length > 0;

  switch (family) {
    case "SECURITY":
      return (
        <>
          <SecurityContext sc={(article as any).security_context} />
          {hasAsset && <MarketContext article={article} />}
          <LayerIndexModule />
        </>
      );
    case "REGULATION":
      return (
        <>
          <RegulationContext reg={regulationRef} />
          {hasAsset && <MarketContext article={article} />}
          <LayerIndexModule />
        </>
      );
    case "GLOBAL_MARKET":
      return (
        <>
          <GlobalMarketContext />
          <LayerIndexModule />
        </>
      );
    case "INSTITUTIONAL":
    case "RWA":
      return (
        <>
          {hasAsset ? <MarketContext article={article} /> : <GlobalMarketContext />}
          <LayerIndexModule />
        </>
      );
    default:
      return (
        <>
          <MarketContext article={article} />
          <LayerIndexModule />
        </>
      );
  }
};
